import { useTheme } from "@mui/material/styles";
import { Box, Button } from "@mui/material";
import PropTypes from "prop-types";

const ResponsiveButtonGroup = ({
  buttons,
  activeButton,
  onChange,
  bgColor = "#E59400",
  width = "500px",
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: width,
        backgroundColor: "#ffffff",
        borderRadius: "5px",
        marginBottom: "0px",
        padding: { xs: "12px", sm: "16px" },
        display: "flex",
        flexWrap: "wrap",
        gap: { xs: "8px", sm: "12px" },
        justifyContent: "center",
        boxShadow: `0 4px 12px ${theme.palette.grey[400]}`,
      }}
    >
      {buttons.map((button, index) => (
        <Button
          key={index}
          variant={activeButton === index ? "contained" : "outlined"}
          onClick={() => onChange(index)}
          sx={{
            flex: { xs: "1 1 calc(50% - 8px)", sm: "1 1 auto" },
            minWidth: { xs: "120px", sm: "140px" },
            padding: { xs: "8px 12px", sm: "10px 16px" },
            fontSize: { xs: "14px", sm: "15px", md: "16px" },
            fontWeight: 500,
            borderRadius: "8px",
            backgroundColor: activeButton === index ? bgColor : "transparent !important",
            color: activeButton === index ? "#ffffff" : theme.palette.grey[800],
            borderColor: activeButton === index ? bgColor : theme.palette.grey[400],
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: activeButton === index ? "#cc8400" : theme.palette.grey[200],
              borderColor: activeButton === index ? "#cc8400" : theme.palette.grey[500],
              color: activeButton === index ? "#ffffff" : theme.palette.grey[900],
            },
            "&:focus": {
              outline: "none !important",
              boxShadow: "none !important",
              backgroundColor: activeButton === index ? bgColor : "transparent !important",
            },
            "&:active": {
              backgroundColor: activeButton === index ? bgColor : "transparent !important",
            },
            "&.Mui-focusVisible": {
              backgroundColor: activeButton === index ? bgColor : "transparent !important",
              outline: "none !important",
              boxShadow: "none !important",
            },
            "&:focus-visible": {
              backgroundColor: activeButton === index ? bgColor : "transparent !important",
              outline: "none !important",
              boxShadow: "none !important",
            },
            textTransform: "none",
          }}
        >
          {button.label}
        </Button>
      ))}
    </Box>
  );
};

ResponsiveButtonGroup.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeButton: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  bgColor: PropTypes.string,
  width: PropTypes.string,
};

export default ResponsiveButtonGroup;
